import * as React from 'react';
import * as classnames from 'classnames/bind';
import {action, observable} from 'mobx';
import {observer} from 'mobx-react';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {MDIcon} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';

const styles = require('./Expander.less');
const cx = classnames.bind(styles);

export enum ExpanderStyle
{
    TextOnly,
    CheckboxAndText
}

export interface ExpanderProps
{
    text:string;
    isInitiallyExpanded?:boolean;
    style?:ExpanderStyle;
    className?:string;
    onIsExpandedChanged?:(isExpanded:boolean)=>(void);
}

@observer
export class Expander extends React.Component<ExpanderProps, any>
{
    @observable
    private _isExpanded:boolean;

    constructor(props:ExpanderProps)
    {
        super(props);
        this._init(props);
    }

    componentWillReceiveProps(props:Readonly<ExpanderProps>): void
    {
        // this._init(props);
    }

    @action.bound
    private _init(props:ExpanderProps)
    {
        if( props.isInitiallyExpanded )
            this._isExpanded = true;
    }

    @action.bound
    private _onClick()
    {
        this._isExpanded = !this._isExpanded;

        const {onIsExpandedChanged} = this.props;
        if( onIsExpandedChanged )
            onIsExpandedChanged(this._isExpanded);
    }

    render()
    {
        let {className, style, text} = this.props;

        const isExpanded = this._isExpanded;

        if( !style )
            style = ExpanderStyle.TextOnly;

        return (
            <Column className={cx('expander', className)}>

                <Row className={cx('controlRow')} onClick={this._onClick}>
                    <Row className={cx('expanderButton', {isExpanded})}
                         onClick={this._onClick}>
                        <MDIcon name={MDIcons.common.ArrowDropright}/>
                    </Row>

                    <Row className={cx('expanderText')}>
                        {text}
                    </Row>
                </Row>

                <Row className={cx('contentRow', {isExpanded})}>
                    {this.props.children}
                </Row>

            </Column>
        );
    }
}
